export const DetalleSistemaUnidadSectorGrupoFields = {
    NombreSistema: 'vchNombreSistema',
    CodSistema: 'sinCodSistema',
    NombreUnidadNegocio: 'vchNombreUnidadNegocio',
    CodUnidadNegocio: 'sinCodUnidadNegocio',
    NombreSectorComercial: 'vchNombreSectorComercial',
    CodSectorComercial: 'sinCodSectorComercial',
    NombreGrupo: 'vchNombreGrupo',
    IdGrupo: 'intIdGrupo',
    NombrePais: 'vchNombrePais',
    CodPais: 'sinCodPais'
} as const

export type DetalleSistemaUnidadSectorGrupoDTO = {
    [DetalleSistemaUnidadSectorGrupoFields.NombreSistema]: string
    [DetalleSistemaUnidadSectorGrupoFields.CodSistema]: number
    [DetalleSistemaUnidadSectorGrupoFields.NombreUnidadNegocio]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodUnidadNegocio]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombreSectorComercial]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodSectorComercial]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombreGrupo]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.IdGrupo]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombrePais]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodPais]: number | null
}

export const SistemaSeguridadFields = {
    CodSistemaPrincipal: 'tinCodSistemaPrincipal',
    NombreSistemaPrincipal: 'vchNombreSistemaPrincipal',
    IconoSistemaPrincipal: 'vchIconoSistemaPrincipal',
    CodSistema: 'sinCodSistema'
} as const

export type SistemaSeguridadDTO = {
    [SistemaSeguridadFields.CodSistemaPrincipal]: number
    [SistemaSeguridadFields.NombreSistemaPrincipal]: string
    [SistemaSeguridadFields.IconoSistemaPrincipal]: string | null
    [SistemaSeguridadFields.CodSistema]: number
}

export const EtapaGrupoSeguridadFields = {
    IdEtapa: 'intIdEtapa',
    NombreEtapa: 'vchNombreEtapa',
    Orden: 'tinOrden',
    IdGrupo: 'intIdGrupo',
    DescGrupo: 'vchDescSegGrupo',
    PermisoTipo: 'tinPermisoTipo',
    PermiteCargarOperaciones: 'bitPermiteCargarOperaciones'
} as const

export type EtapaGrupoSeguridadDTO = {
    [EtapaGrupoSeguridadFields.IdEtapa]: number
    [EtapaGrupoSeguridadFields.NombreEtapa]: string
    [EtapaGrupoSeguridadFields.Orden]: number
    [EtapaGrupoSeguridadFields.IdGrupo]: number | null
    [EtapaGrupoSeguridadFields.DescGrupo]: string | null
    [EtapaGrupoSeguridadFields.PermisoTipo]: number | null
    [EtapaGrupoSeguridadFields.PermiteCargarOperaciones]: boolean | null
}

export const SeguridadWorkflowFullFields = {
    CodSistema: 'sinCodSistema',
    NombreSistemaPrincipal: 'vchNombreSistemaPrincipal',
    NombreSistema: 'vchNombreSistema',
    NombreEtapa: 'vchNombreEtapa',
    DescGrupo: 'vchDescSegGrupo',
    NombreSectorComercial: 'vchNombreSectorComercial',
    NombreUnidadNegocio: 'vchNombreUnidadNegocio',
    ApellidoYNombre: 'vchApellidoYNombreMostrar',
    Permiso: 'vchPermiso'
} as const

export type SeguridadWorkflowFullDTO = {
    [SeguridadWorkflowFullFields.CodSistema]: number
    [SeguridadWorkflowFullFields.NombreSistemaPrincipal]: string
    [SeguridadWorkflowFullFields.NombreSistema]: string
    [SeguridadWorkflowFullFields.NombreEtapa]: string
    [SeguridadWorkflowFullFields.DescGrupo]: string
    [SeguridadWorkflowFullFields.NombreSectorComercial]: string | null
    [SeguridadWorkflowFullFields.NombreUnidadNegocio]: string | null
    [SeguridadWorkflowFullFields.ApellidoYNombre]: string
    [SeguridadWorkflowFullFields.Permiso]: string
}

export const UsuarioGrupoSeguridadFields = {
    IdUsuario: 'intIdUsuario',
    CodUsuario: 'vchCodUsuario',
    ApellidoYNombre: 'vchApellidoYNombreMostrar',
    Mail: 'vchMail'
} as const

export type UsuarioGrupoSeguridadDTO = {
    [UsuarioGrupoSeguridadFields.IdUsuario]: number
    [UsuarioGrupoSeguridadFields.CodUsuario]: string
    [UsuarioGrupoSeguridadFields.ApellidoYNombre]: string
    [UsuarioGrupoSeguridadFields.Mail]: string
}
